import { useFormik } from "formik"
import { Button, Checkbox, Dialog, Grid, TextField } from "src/components"
import Alert from "src/components/Alert"
import DialogActions from "src/components/DialogActions"
import DialogContent from "src/components/DialogContent"
import DialogTitle from "src/components/DialogTitle"
import ParametreGrupEnum from "src/enums/ParametreGrupEnum"
import { translate } from "src/i18n/tHelper"
import VwKurumMailGonderimAyarlariDTO from "src/models/Settings/Generals/VwKurumMailGonderimAyarlariDTO"
import GnlParametreSelect from "src/parts/Genel/gnl.parametre.select"
import KurumAutoComplete from "src/parts/Kurum/kurum.autocomplete"
import OrgYetkiAutocomplete from "src/parts/Organizasyon/OrgYetkiAutocomplete"
import { useKurumMailGonderimAyarDuzenleMutation, useKurumMailGonderimAyarEkleMutation } from "src/services/geneltanimlar/KurumMailGonderimAyarlariApi"
import { useAppDispatch, useAppSelector } from "src/store"
import { KurumMailGonderimAyarlariSlice } from "src/store/Slices/GenelTanimlar/KurumMailGonderimAyarlariSlice"
import SnackbarUtils from "src/utils/SnackbarUtils"
import * as yup from 'yup';

const translatePath = "pages|KurumMailGonderimAyarlari"
const KurumMailGonderimAyarEkle = (): JSX.Element => {

    const state = useAppSelector(state => state.kurumMailGonderimAyarlari);
    const dispatch = useAppDispatch();
    const [ekle, ekleState] = useKurumMailGonderimAyarEkleMutation();
    const [duzenle, duzenleState] = useKurumMailGonderimAyarDuzenleMutation();

    const formik = useFormik<VwKurumMailGonderimAyarlariDTO>({
        enableReinitialize: true,
        initialValues: state.activeRow,
        validateOnChange: false,
        async onSubmit(values) {

            if (!ekleState.isLoading && !duzenleState.isLoading) {
                try {
                    if (!values.id) {
                        await ekle(values)
                            .unwrap()
                            .then((response) => {

                                const newData = [...state.data, response];
                                dispatch(KurumMailGonderimAyarlariSlice.actions.setData(newData));
                                SnackbarUtils.success(translate(translatePath, 'Kayıt başarıyla eklendi.'));

                            })
                            .catch((e) => {
                                SnackbarUtils.error(translate(translatePath, 'Kayıt eklenirken bir hatayla karşılaşıldı.'));
                            });
                        dispatch(KurumMailGonderimAyarlariSlice.actions.setOpen(false));

                    } else {
                        await duzenle(values)
                            .unwrap()
                            .then((response) => {

                                dispatch(KurumMailGonderimAyarlariSlice.actions.setData(state.data.map((d) => (d.id === response.id ? response : d))));
                                //api kendi snackbar gösteriyor

                            })
                            .catch((e) => {
                                SnackbarUtils.error(translate(translatePath, 'Kayıt düzenlenirken bir hatayla karşılaşıldı.'));
                            });
                        dispatch(KurumMailGonderimAyarlariSlice.actions.setOpen(false));

                    }
                } catch (error: any) {
                    SnackbarUtils.error(error.message);
                }
            }



        },
        validationSchema: yup.object().shape({
            fkOrganizasyon: yup.string().trim().required('Organizasyon alanı zorunludur.'),
            fkKurum: yup.string().trim().required('Kurum alanı zorunludur.'),
            mailAdres: yup.string().matches(/^(\s*[\w.-]+@[\w.-]+\.[\w]{2,})(\s*;\s*[\w.-]+@[\w.-]+\.[\w]{2,})*\s*$/,
                'Lütfen tüm mail adreslerini doğru formatta girin ve noktalı virgül (;) ile ayırın.').required('Mail alanı zorunludur.'),
            gonderimSure: yup.number().required('Gönderim Süre alanı zorunludur.'),
            gonderimYontem: yup.number().required('Gönderim Yöntem alanı zorunludur.'),
            gonderimSureYontem: yup.number().required('Gönderim Süre Yöntem tipi zorunludur.'),

        })
    });
    return (
        <Dialog fullWidth open={state.open} maxWidth="sm">
            <DialogTitle>{translate(translatePath, "Kurum Mail Gönderim Ayarları")}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <OrgYetkiAutocomplete
                            required={true}
                            label={translate(translatePath, "Organizasyon")}
                            name="fkOrganizasyon"
                            value={formik.values.fkOrganizasyon}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.fkOrganizasyon)}
                            helperText={formik.errors.fkOrganizasyon}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <KurumAutoComplete
                            required={true}
                            label={translate(translatePath, "Kurum")}
                            name="fkKurum"
                            value={formik.values.fkKurum}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.fkKurum)}
                            helperText={formik.errors.fkKurum}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Alert variant="outlined" severity="info" sx={{ marginBottom: 2, fontSize: 13 }}>
                            {
                                translate(translatePath, "';' ile ayırarak mail adreslerini giriniz.")
                            }
                        </Alert>
                        <TextField
                            required={true}
                            name="mailAdres"
                            label={translate(translatePath, "Mail Adresleri")}
                            placeholder={translate(translatePath, "';' ile ayırarak mail adreslerini giriniz.")}
                            multiline
                            value={formik.values.mailAdres}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.mailAdres)}
                            helperText={formik.errors.mailAdres}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {/* <Select
                            value={formik.values.gonderimYontem}
                            label="Gönderim Yöntemi"
                            id="gonderimYontem"
                        >
                            <MenuItem value={1}>Organizasyon</MenuItem>
                            <MenuItem value={2}>Kurum</MenuItem>
                            <MenuItem value={3}>Hepsi</MenuItem>

                        </Select> */}



                        <GnlParametreSelect
                            required
                            label={translate(translatePath, "Gönderim Yöntem")}
                            parametreType={ParametreGrupEnum.GonderimYontem}
                            name="gonderimYontem"
                            value={formik.values.gonderimYontem}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.gonderimYontem)}
                            helperText={formik.errors.gonderimYontem}
                        />

                    </Grid>
                    <Grid item xs={12}>
                        {/* <Select
                            value={formik.values.gonderimYontem}
                            label="Gönderim Süre Yöntemi"
                            id="gonderimSureYontem"
                        >
                            <MenuItem value={1}>Dakika</MenuItem>
                            <MenuItem value={2}>Saat</MenuItem>
                            <MenuItem value={3}>Gün</MenuItem>

                        </Select> */}
                        <Grid container>
                            <Grid item xs={6}>
                                <TextField
                                    required={true}
                                    name="gonderimSure"
                                    label={translate(translatePath, "Gönderim Süre")}
                                    value={formik.values.gonderimSure}
                                    onChange={formik.handleChange}
                                    error={Boolean(formik.errors.gonderimSure)}
                                    helperText={formik.errors.gonderimSure}
                                />
                            </Grid>
                            <Grid item xs={6}>

                                <GnlParametreSelect
                                    required
                                    label={translate(translatePath, "Gönderim Süre Yöntem")}
                                    parametreType={ParametreGrupEnum.GonderimSureYontem}
                                    name="gonderimSureYontem"
                                    value={formik.values.gonderimSureYontem}
                                    onChange={formik.handleChange}
                                    error={Boolean(formik.errors.gonderimSureYontem)}
                                    helperText={formik.errors.gonderimSureYontem}
                                />
                            </Grid>

                        </Grid>

                    </Grid>
                    <Grid item xs={12}>
                        <Checkbox
                            label={translate(translatePath, 'Aktif')}
                            name="gonderimAktif"
                            onChange={(e) => {
                                const newValue = e.target.checked ? "E" : "H";
                                formik.setFieldValue('gonderimAktif', newValue);
                            }}
                            checked={formik.values.gonderimAktif === "E"}
                            sx={{width:"auto"}}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button customType="save" onClick={formik.submitForm} />
                <Button customType="cancel" onClick={() => dispatch(KurumMailGonderimAyarlariSlice.actions.setOpen(false))} />
            </DialogActions>
        </Dialog>
    )
}

export default KurumMailGonderimAyarEkle